<template lang="pug">
  .component-entity-page
    component(v-if="item", :is="itemComponent", :item="item", :type="'expanded'", :id="item.id", @refresh="refresh")

</template>
<script type="text/babel">
  import KeplerBackofficeSdk from "../../lib/kepler/backoffice";

  export default {
    name: "EntityPage",
    components: {},
    data() {
      return {
        itemComponent: null,
        item: null,
        type: 'expanded'
      }
    },
    created() {
      this.$watch(function () {
        return this.$route.meta
      }, function (newVal, oldVal) {
        this.setup()
      })
      this.setup()
    },
    methods: {
      setup: function () {
        var source = this.$route.meta.source

        KeplerBackofficeSdk[source].select(this.$route.params.id).get((response) => {
          this.item = response
          this.itemComponent = this.$route.meta.entityComponent
        })
      },
      refresh() {
        this.setup()
      }
    },
    computed: {}
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// EntityPage.vue?7a76487e